import React from 'react';
import cls from 'classnames';
import styles from './index.module.scss';
const OrderPicker = ({ handleSelect, value, days }) => {
    return (React.createElement(React.Fragment, null, days.map((item) => (React.createElement("div", { key: item.value, className: cls(styles.item, {
            [styles.selected]: item.value === +value,
            [styles.lastDay]: item.value === -1
        }) },
        React.createElement("button", { type: 'button', onClick: () => {
                handleSelect(item);
            } }, item.value === -1 ? item.label : item.value))))));
};
export default OrderPicker;
